<template>
  <a
    href="#"
    @click.prevent="toggleAutoplay"
    @mouseover="showTooltip"
    @mouseleave="hideTooltip"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    :title="$t('Toggle video autoplay') + ' (beta)'"
    v-if="compatibleVideoComponents"
  >
    <i
      :class="{
        far: !autoplay,
        fas: autoplay,
        'text-success': autoplay,
        'fa-play-circle': true,
      }"
    ></i>
  </a>
</template>

<script>
export default {
  methods: {
    showTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).show()
    },
    hideTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).hide()
    },
    toggleAutoplay() {
        this.$store.commit('toggleAutoplay')
    },
  },
  computed: {
      compatibleVideoComponents() {
          if (this.$store.getters.notSeenVideoComponents) {
              return this.$store.getters.notSeenVideoComponents.length
          }
          return false
      },
      autoplay() {
          return this.$store.state.autoplay
      },
  },
}
</script>
